import { Component, Host, h, Prop, Element } from '@stencil/core';
import { ISize } from '../../../constant/components/cmsIcon';
import { SVG_CONFIG } from '../../../constant/svg';
@Component({
  tag: 'cms-icon',
  styleUrl: 'cms-icon.scss',
  shadow: false,
})
export class CmsIcon {
  /**
   * The name of icon.
   */
  @Prop() dataIcon: string = '';

  /**
   * The size of the svg element.
   */
  @Prop() dataSize: ISize = '1x';

  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';

  /**
   * Set any icon to rotate.
   */
  @Prop() dataSpinner: boolean = false;

  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  @Element() elRoot: HTMLElement;

  private SIZE_TO_EM = {
    xs: '0.75em',
    sm: '0.875em',
    lg: '1.333em',
    '1x': '1em',
    '2x': '2em',
    '3x': '3em',
    '4x': '4em',
    '5x': '5em',
    '6x': '6em',
    '7x': '7em',
    '8x': '8em',
    '9x': '9em',
    '10x': '10em',
  };

  connectedCallback() {
    this.elRoot.innerHTML = '';
  }

  getInnerHtml() {
    if (!SVG_CONFIG[this.dataIcon]) {
      return `<cms-icon-${this.dataIcon} data-width="${this.getWidth()}" data-height="${this.getHeight()}" data-fill="${
        this.dataFill
      }"></cms-icon-${this.dataIcon}`;
    } else {
      return '';
    }
  }

  private getWidth = () => {
    if (this.dataWidth) {
      return this.dataWidth;
    } else if (this.dataSize) {
      return this.SIZE_TO_EM[this.dataSize];
    } else {
      return '1em';
    }
  };

  private getHeight = () => {
    if (this.dataHeight) {
      return this.dataHeight;
    } else if (this.dataSize) {
      return this.SIZE_TO_EM[this.dataSize];
    } else {
      return '1em';
    }
  };

  render() {
    return (
      <Host>
        {SVG_CONFIG[this.dataIcon] ? (
          /*@ts-ignore*/
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox={SVG_CONFIG[this.dataIcon].viewBox}
            focusable="false"
            aria-hidden="true"
            fill-rule="evenodd"
            clip-rule="evenodd"
            width={this.getWidth()}
            height={this.getHeight()}
            class={`${this.dataSpinner ? 'cms-icon-spin' : ''}`}
          >
            {SVG_CONFIG[this.dataIcon].path.map(r => {
              return <path fill={this.dataFill} d={r} />;
            })}
          </svg>
        ) : (
          <span innerHTML={this.getInnerHtml()}></span>
        )}
      </Host>
    );
  }
}
